<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Choose Your Impact">
                    <FormRow inline>
                        <LazyCurrencySelector :currencies="['USD', 'ILS', 'CAD']"/>
                    </FormRow>
                    <AmountSelectorList/>
                    <ErrorLabel field="amount" />
                </FormSection>
                <FormSection title="Your Details">
                    <FormRow inline>
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                      <Consent privacy="https://www.ouisrael.org/privacy-policy/"/>
                  </FormRow>
                </FormSection>
                <FormSection title="Billing Information">
                    <DonorAddress />
                </FormSection>
                <FormSection title="Payment Information" last>
                  <FormRow>
                    <Receipt />
                  </FormRow>
                  <FormRow inline>
                    <FormCol field="card" :showLabel="false" />
                  </FormRow>
                </FormSection>

                <PaymentButton showAmount btnText="Donate"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.other-means {
    font-size: 13px;
    margin-top: 10px;
    line-height: 1.6;
    background: #fffff4;
    padding: 10px;
    border-radius: 4px;
    border: 1px solid #e8e8d8;
}
::v-deep .label-description {
  font-size: 14px;
  font-weight: 600;
}
::v-deep .amount-row {
  min-width: 100%;
  max-width: 100%;
}
</style>

